// extracted by mini-css-extract-plugin
export default {"drop_container":"DragDropFile_drop_container__U+e1Y","drop_title":"DragDropFile_drop_title__uBW5f","file_image":"DragDropFile_file_image__f06Uo"};